import * as React from 'react';
import { render } from 'react-dom';
import * as superagent from 'superagent';

import { ISelfSimilarObjectsResponse } from './components/self_similar_objects';

interface ISelfSimilarObjectsResponseSuccess {
  body: {
    status: string;
    data: {
      offers: ISelfSimilarObjectsResponse[];
    }
  }
}

interface ISelfSimilarObjectsResponseError {
  error: {
    status: number;
    message: string;
  }
}

function getSelfSimilarObjects(realtyOfferId: number): Promise<ISelfSimilarObjectsResponse[]> {
  return new Promise((resolve, reject) => {
    superagent
      .get('/cian-api/site/v1/get-user-similar-offers/')
      .query({ realtyOfferId })
      .send()
      .end((
        error: ISelfSimilarObjectsResponseError,
        response: ISelfSimilarObjectsResponseSuccess
      ) => {
        if (error) {
          reject(error);
        }

        resolve(response.body.data.offers);
      });
  });
}

export default function initSelfSimilarObjects() {
  (window as any).renderSelfSimilarObjects = function(container: Element, realtyID: number) {
    getSelfSimilarObjects(realtyID)
      .then(offers => {
        if (offers.length) {
          require.ensure(['./components/self_similar_objects.tsx'], () => {
            const SelfSimilarObjects = require('./components/self_similar_objects').default;

            render(
              <SelfSimilarObjects offers={offers} />,
              container,
            );
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/bundles/self_similar_objects/index.tsx